import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { CardOverview, MaterialBox } from 'components';
import { STRUCTURES_PATHS } from 'constants/paths';
import { DifettositaSovrastruttureEServiziOptions } from 'constants/selectOptions';
import { inspectionTabMapping } from 'utils/inspectionTabMapping';
import { handleDynamicInspectionsTabChange } from 'utils/utilities';
import { Row } from '../TabL1.styles';

const Servizi = ({ overviewL1, structure }) => {
  const params = useParams();
  const id = params.structureId;
  const navigate = useNavigate();

  // e-2026-06-t21 — id di navigazione L0,1,2 (dal dettaglio ponte), non
  // l'id "di qualunque tipologia" di overviewL1: quest'ultimo può puntare
  // a un'attività L3 per propagazione, vedi apps/api/docs/
  // navigazione-ultima-attivita-per-livello.md.
  const lastInspectionId = structure?.requestUserLastValidL012InspectionId;

  const paliIlluminazione = overviewL1?.servizi?.paliIlluminazione?.difettosita;
  const convogliamentoAcque =
    overviewL1?.servizi?.convogliamentoAcque?.difettosita;
  const sottoservizio = overviewL1?.servizi?.sottoservizi?.difettosita;
  return (
    <CardOverview
      title={'Servizi'}
      subtitle={`Rilievo dei degradi`}
      buttonText={'Approfondisci'}
      buttonDisabled={lastInspectionId ? false : true}
      height="auto"
      onClick={() =>
        handleDynamicInspectionsTabChange(
          inspectionTabMapping.L1,
          inspectionTabMapping.Servizi,
          null,
          navigate,
          STRUCTURES_PATHS.STRUCTURES_LIST,
          id,
          lastInspectionId
        )
      }
    >
      <Row style={{ marginTop: 12 }}>
        <MaterialBox
          topic={'Pali illuminazione'}
          defect={paliIlluminazione}
          enumOptions={DifettositaSovrastruttureEServiziOptions}
        />
        <MaterialBox
          topic={'Convogliamento acque'}
          defect={convogliamentoAcque}
          enumOptions={DifettositaSovrastruttureEServiziOptions}
        />
        <MaterialBox
          topic={'Sottoservizi'}
          defect={sottoservizio}
          enumOptions={DifettositaSovrastruttureEServiziOptions}
        />
      </Row>
    </CardOverview>
  );
};

export { Servizi };

Servizi.propTypes = {
  overviewL1: PropTypes.obj,
  structure: PropTypes.object,
};
